import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [ "checkbox" ]

  choose(event) {
    event.preventDefault()
    this.checkboxTargets.forEach( item => item.checked = true );
  }

  reset(event){
    event.preventDefault()
    this.checkboxTargets.forEach( item => item.checked = false );
  }
}